import { modelOptions, prop } from '@typegoose/typegoose';

@modelOptions({
  schemaOptions: { collection: 'dashboards_pdfs' },
  options: { customName: 'dashboards_pdfs' },
})
export class DashboardsPdfs {
  @prop({
    expires: 60,
    type: Date,
    index: true,
  })
  insertedAt: Date;
}
